import { Modal } from 'antd';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Spinner from 'components/Spinner/Spinner';

import EditWorkStepForm from './EditWorkStepForm';
import { workStepsModal } from './data/actions';
import { MODES } from './data/constants';
import { getIsLoading, getIsOpen, getMode } from './data/reducer';

const CenteredSpinner = styled.div`
  display: flex;
  justify-content: center;
`;

const connector = connect(
  (state) => ({
    isLoading: getIsLoading(state),
    isModalOpen: getIsOpen(state),
    mode: getMode(state),
  }),
  {
    closeModal: workStepsModal.close,
  },
);

const WorkStepModal = ({ closeModal, isLoading, isModalOpen, mode }) => {
  return (
    <Modal
      destroyOnClose={true}
      title={
        mode === MODES.EDIT ? 'Edit Workflow Step' : 'Create Workflow Step'
      }
      visible={isModalOpen}
      onCancel={closeModal}
      footer={null}
      width={576}
    >
      {isLoading ? (
        <CenteredSpinner>
          <Spinner />
        </CenteredSpinner>
      ) : (
        <EditWorkStepForm />
      )}
    </Modal>
  );
};

export default connector(WorkStepModal);
